import axios from "axios";
import React from "react";
import { getWeekNumber } from "../utils/snippets";
import { operators } from "../config";

function ProductView(props) {
  const curWeek = getWeekNumber(new Date());
  const { setProduct, product, tapes, reload, setReload, ads } = props;
  const prod = ads.find((el) => el.index === product);
  const prodtapes = tapes.filter(
    (el) => el.campaignId === prod.campaignId && el.format === prod.format
  );

  const [formData, setFormData] = React.useState({
    operatorId: operators[0].value,
    busNumber: "",
    amount: 1,
    week: curWeek,
  });
  const [removals, setRemovals] = React.useState([]);

  return (
    <div>
      <button
        className="back-button"
        onClick={() => {
          setReload(reload + 1);
          setProduct(undefined);
        }}
      >
        Takaisin Kampanjaan
      </button>
      <br />
      <h3 className="product-title">
        {prod.client +
          " " +
          prod.format +
          " viikot " +
          prod.start +
          " - " +
          prod.end}
      </h3>
      <div className={"infoContainer"}>
        {prod.info && prod.info.length ? "Lisätiedot: " + prod.info : ""}
      </div>
      <div>
        <form
          className="product-form"
          onSubmit={(event) => {
            event.preventDefault();
            axios
              .post(process.env.REACT_APP_BACKEND_URL + "/addTaping", {
                campaign: {
                  busNumber:
                    parseInt(formData.busNumber) +
                    parseInt(formData.operatorId),
                  amount: formData.amount,
                  week: formData.week,
                  client: prod.client,
                  format: prod.format,
                  campaignId: prod.campaignId,
                },
                removals: removals,
              })
              .then((res) => {
                setFormData({
                  operatorId: formData.operatorId,
                  busNumber: "",
                  amount: 1,
                  week: curWeek,
                });
                setReload(reload + 1);
              });
          }}
        >
          <hr style={{ width: "90%" }}></hr>

          <label>Liikennöitsijä</label>
          <select
            style={{
              fontSize: "12px",
              textAlign: "center",
              padding: "10px",
              margin: "auto",
              maxWidth: "400px",
            }}
            onChange={(event) =>
              setFormData({ ...formData, operatorId: event.target.value })
            }
            value={formData.operatorId}
          >
            {operators.map((operator) => (
              <option key={operator.value} value={operator.value}>
                {operator.name}
              </option>
            ))}
          </select>

          <label>Bussinumero:</label>
          <input
            value={formData.busNumber}
            onChange={(event) =>
              setFormData({ ...formData, busNumber: event.target.value })
            }
            type={"number"}
          />
          <label>Yliteippaukset/poistot:</label>
          {tapes.reduce((pre, cur, i) => {
            let index = removals.findIndex((el) => el === cur);
            if (cur.busNumber === formData.busNumber && cur.removed !== "X")
              pre.push(
                <div
                  key={"delete " + i}
                  className={
                    index === -1 ? "removal-unselected" : "removal-selected"
                  }
                  onClick={(e) => {
                    if (index === -1) setRemovals([...removals, cur]);
                    else setRemovals(removals.filter((el, i) => i !== index));
                  }}
                >
                  {cur.format + " " + cur.client}
                </div>
              );
            return pre;
          }, [])}
          <label>Teippimäärä:</label>
          <input
            value={formData.amount}
            onChange={(event) =>
              setFormData({ ...formData, amount: event.target.value })
            }
            type={"number"}
          />
          <label>Teippausviikko:</label>
          <input
            value={formData.week}
            onChange={(event) =>
              setFormData({ ...formData, week: event.target.value })
            }
            type={"number"}
          />
          <button type={"submit"}>Lisää</button>
        </form>
      </div>
      <p className="product-buses"> Teipatut bussit:</p>
      <div id={"buslist"}>
        {prodtapes.length > 0
          ? prodtapes.map((el, index) => (
              <div key={"Bus " + index} className="bus-item">
                {[
                  el.busNumber +
                    (Number(el.amount) === 1 ? "" : " : " + el.amount),
                  el.removed === "X" ? (
                    " poistettu/yliteipattu"
                  ) : (
                    <div
                      key="delete-icon"
                      className={"delete-icon"}
                      onClick={(event) => {
                        event.preventDefault();
                        if (
                          window.confirm(
                            "Poista rivi: " +
                              JSON.stringify(el) +
                              " Sheetsistä \nOletko varma?"
                          )
                        ) {
                          axios
                            .post(
                              process.env.REACT_APP_BACKEND_URL +
                                "/deleteTaping",
                              el
                            )
                            .then((res) => {
                              setRemovals([]);
                              setReload(reload + 1);
                            });
                        }
                      }}
                    >
                      {"poista virheenä"}
                    </div>
                  ),
                ]}
              </div>
            ))
          : "-"}
      </div>
      <button
        className={
          prod.ready === "X" ? "makeNotReadyButton" : "makeReadyButton"
        }
        onClick={(event) => {
          axios
            .post(process.env.REACT_APP_BACKEND_URL + "/updateCampaign", {
              ...prod,
              ready: prod.ready === "X" ? "" : "X",
            })
            .then((res) => {
              console.log(res);
              setReload(reload + 1);
            });
        }}
      >
        {prod.ready === "X" ? "Muuta keskeneräiseksi" : "Merkitse valmiiksi"}
      </button>
    </div>
  );
}

export default ProductView;
